import React from 'react';
import Speedometer from './Speedometer';
import TestButton from './TestButton';
import PhaseIndicator from './Indicator';
import ResultsGrid from './ResultsGrid';
import SpeedGrade from './SpeedGrade';
import ShareButton from './ShareButton';

const SpeedTestArea = ({ 
  currentPhase, 
  currentSpeed, 
  results, 
  isActive, 
  progress,
  onStart,
  onReset
}) => {
  return (
    <div className="glass-card rounded-3xl p-8 bg-white dark:bg-gray-800 border border-[#1E9B4C]/20 dark:border-green-500/20">
      <Speedometer 
        currentPhase={currentPhase}
        currentSpeed={currentSpeed}
        results={results}
        isActive={isActive}
        progress={progress}
      />
      
      <PhaseIndicator isActive={isActive} currentPhase={currentPhase} />
      
      <TestButton 
        currentPhase={currentPhase}
        isActive={isActive}
        onStart={onStart}
        onReset={onReset}
      />
      
      <div className="mt-8">
        <SpeedGrade results={results} currentPhase={currentPhase} />
        <ResultsGrid results={results} currentPhase={currentPhase} />
        <ShareButton results={results} currentPhase={currentPhase} />
      </div>
    </div>
  );
};

export default SpeedTestArea;